//musí být jQuery ne $. Jinak to nefunguje :)
//var jQuery = require('jquery');
define(['jquery'], function($) {

  jQuery.migrateMute = true;
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/ramjet/new/migratemute.js